import { render, staticRenderFns } from "./ProfilePrescriber.vue?vue&type=template&id=af94c372&scoped=true&"
import script from "./ProfilePrescriber.vue?vue&type=script&lang=ts&"
export * from "./ProfilePrescriber.vue?vue&type=script&lang=ts&"
import style0 from "./ProfilePrescriber.vue?vue&type=style&index=0&id=af94c372&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af94c372",
  null
  
)

export default component.exports